var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChooseCardCenterImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 81,
    viewBox: "0 0 71 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1189 79.7638C36.4055 80.2722 34.5843 80.2722 32.871 79.7638C28.3341 78.4176 21.5157 75.5519 15.3501 69.596C5.24747 59.8372 0.125 45.0924 0.125 25.7711V20.767C0.125 17.2699 2.55993 14.2514 5.97402 13.4942C10.2765 12.5402 14.5095 11.16 18.6391 9.36161C23.0867 7.42483 27.2776 5.06242 31.1751 2.29917C33.7651 0.462791 37.2255 0.462793 39.8156 2.29908C43.7133 5.06242 47.9044 7.42484 52.352 9.36172C56.4811 11.1598 60.7141 12.5401 65.0163 13.4941C68.4304 14.2513 70.8652 17.2699 70.8652 20.7669V25.7712C70.8652 45.0925 65.7428 59.8372 55.6402 69.5961C49.4742 75.5518 42.6559 78.4175 38.1189 79.7638Z",
    fill: "#004424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8068 31.0059L31.7838 45.0287L25.1841 38.4291L19.9785 43.6347L31.7838 55.4401L51.0123 36.2115L45.8068 31.0059Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseCardCenterImg);
export default __webpack_public_path__ + "static/media/choose-card-center-img.14721b0eb3c405381d97a8bd3fbd17ec.svg";
export { ForwardRef as ReactComponent };